import {
  PRODUCTBLOCK_LOADING,
  GET_PRODUCTBLOCK,
  GET_PRODUCTBLOCK_SUCCESS,
  GET_PRODUCTBLOCK_FAIL,
  ADD_PRODUCTBLOCK_SUCCESS,
  ADD_PRODUCTBLOCK_FAIL,
  DELETE_PRODUCTBLOCK_SUCCESS,
  DELETE_PRODUCTBLOCK_FAIL,
  UPDATE_PRODUCTBLOCK_SUCCESS,
  UPDATE_PRODUCTBLOCK_FAIL,
  PRODUCTBLOCK_RESET,
  PRODUCTBLOCK_RESET_CREATE
} from "./actionType";

const INIT_STATE = {
  productBlocks: [],
  productBlockAdded: {},
  error: {},
};

const ProductBlock = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_PRODUCTBLOCK_SUCCESS:
      switch (action.payload.actionType) {
        case GET_PRODUCTBLOCK:
          return {
            ...state,
            productBlocks: action.payload.data,
            isProductBlockCreated: false,
            isProductBlockSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_PRODUCTBLOCK_FAIL:
      switch (action.payload.actionType) {
        case GET_PRODUCTBLOCK_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isProductBlockCreated: false,
            isProductBlockSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_PRODUCTBLOCK: {
      return {
        ...state,
        isProductBlockCreated: false,
        loading: true,
      };
    }

    case PRODUCTBLOCK_LOADING: {
      return {
        ...state,
        isProductBlockCreated: false,
        loading: true,
      };
    }

    case ADD_PRODUCTBLOCK_SUCCESS:
      return {
        ...state,
        isProductBlockCreated: true,
        loading: false,
        productBlocks: Array.isArray(action.payload.data) ? [...state.productBlocks, ...action.payload.data] : [action.payload.data, ...state.productBlocks],
        productBlockAdded: action.payload.data,
      };

    case ADD_PRODUCTBLOCK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_PRODUCTBLOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        productBlocks: state.productBlocks.filter(
          productBlock => productBlock.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_PRODUCTBLOCK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_PRODUCTBLOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        productBlocks: state.productBlocks.map(productBlock =>
          productBlock.id.toString() === action.payload.data.id.toString() ? { ...productBlock, ...action.payload.data } : productBlock
        ),
      };

    case UPDATE_PRODUCTBLOCK_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case PRODUCTBLOCK_RESET_CREATE:
      return {
        ...state,
        isProductBlockCreated: false,
      };

    case PRODUCTBLOCK_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default ProductBlock;